import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminModal.css';

const LeadDetailsModal = ({ isOpen, onClose, lead }) => {
  useEffect(() => {
  }, [isOpen]);

  if (!isOpen || !lead) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Lead Details</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <p><strong>ID:</strong> #{lead.id}</p>
          <p><strong>Full Name:</strong> {lead.get_full_name}</p>
          <p><strong>Email:</strong> {lead.email}</p>
          <p><strong>Service:</strong> {lead.service_display || (lead.service ? lead.service.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '-')}</p>
          <p><strong>Message:</strong> {lead.message || '-'}</p>
          <p><strong>Created At:</strong> {lead.formatted_created_at}</p>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsModal;